<template>
  <div class="bg-white">
    <table class="w-100 table-striped">
      <thead>
        <th class="py-3 px-2">TRANSACTION ID</th>
        <th class="py-3 px-2">CREATOR BY</th>
        <th class="py-3 px-2">EFFECTIVE DATE</th>
        <th class="py-3 px-2">ACTION</th>
      </thead>
      <tbody v-if="!loading">
        <template v-for="(item, i) in adjustments.data">
          <tr :key="`${i}`">
            <td class="py-3 px-2">
              TRX-ADJSRH-{{ item?.id }}-{{
                item?.effective_date
                  ? moment(item?.effective_date).format('MMYYYY')
                  : ''
              }}
            </td>
            <td class="py-3 px-2">
              {{ item?.user?.requestor?.name ?? '-' }}
            </td>
            <td class="py-3 px-2">{{ item?.effective_date ?? '-' }}</td>
            <td class="py-3 px-2" style="width: 120px">
              <b-dropdown text="Action" size="sm" variant="outline-primary">
                <b-dropdown-item
                  @click="
                    () => {
                      showCanvas = true
                      selectedData = item
                    }
                  "
                >
                  View Detail Transaction
                </b-dropdown-item>
                <template v-if="item?.state == 'requested'">
                  <b-dropdown-item
                    @click="() => handleConfirm(item, 'approve')"
                  >
                    <i class="fa fa-thumbs-up text-success mr-1"></i>
                    Approved
                  </b-dropdown-item>
                  <b-dropdown-item @click="() => handleConfirm(item, 'reject')">
                    <i class="fa fa-close text-danger mr-2"></i>
                    Rejected
                  </b-dropdown-item>
                </template>
              </b-dropdown>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-if="loading" class="w-100 d-flex justify-content-center py-5">
      <b-spinner></b-spinner>
    </div>
    <div
      v-if="!loading && !adjustments?.data?.length"
      class="w-100 d-flex justify-content-center py-4"
    >
      No Data Here!
    </div>

    <!-- Pagination Section -->
    <div
      v-if="adjustments?.data?.length"
      class="mt-4 d-flex align-items-center w-100 justify-content-between"
    >
      <p class="mb-0">
        Total Rows:
        <strong class="text-black">{{ adjustments.total }}</strong>
      </p>
      <div class="d-flex justify-content-end">
        <b-pagination
          class="mb-0 mr-3"
          @change="
            (page) => {
              adjustments.page = page
              fetchData()
            }
          "
          v-model="adjustments.page"
          :total-rows="adjustments.total"
          :per-page="adjustments.perPage"
          first-number
          align="center"
        ></b-pagination>
        <b-form-select
          plain
          v-model="adjustments.perPage"
          :options="limitOptions"
          style="width: 100px"
          @input="fetchData"
        ></b-form-select>
      </div>
    </div>

    <!-- SIDEBAR -->
    <CustomSidebar v-model="showCanvas" title="Detail Running Hours" size="xl">
      <div class="bg-white shadow-sm p-4" >
        <FormAdjustmentRunningHours
          v-if="showCanvas"
          :selectedData="selectedData"
          @refetch="fetchData"
          @close="showCanvas = false"
          :vehiclePowerId="dataRh?.subItem?.vehicle_power_id"
        />
      </div>
    </CustomSidebar>
  </div>
</template>

<script>
import FormAdjustmentRunningHours from '../RunningHourNew/FormAdjustmentRunningHours.vue'
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import moment from 'moment'

export default {
  components: { FormAdjustmentRunningHours, CustomSidebar },
  props: {
    dataRh: {
      type: Object,
      required: false,
    },
    month: {
      type: String,
      required: false,
    },
    year: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      showCanvas: false,
      selectedData: null,
      limitOptions: limitOptions,
      adjustments: {
        page: 1,
        perPage: 10,
        totalPage: 1,
        total: 0,
        data: [],
      },
    }
  },
  computed: {
    moment() {
      return moment
    },
  },
  methods: {
    ...maintenanceActions,
    ...pmsActions,
    ...fleetsActions,
    async handleAction(item, action) {
      try {
        const actMsg = action == 'reject' ? 'Reject' : 'Approve'
        const res = await this.saveAdjustmentRunningHourAction({
          action,
          id: item.id,
        })
        this.$swal(
          'Success',
          res?.data?.message ?? `Success ${actMsg} Adjusment Running Hours`,
          'success'
        )
        this.fetchData()
      } catch (error) {
        console.log(error)
        this.$swal(
          'Error',
          error.response?.data?.message ??
            `Failed ${actMsg} Adjusment Running Hours`,
          'error'
        )
      }
    },
    handleConfirm(data, action) {
      const actMsg = action == 'reject' ? 'Reject' : 'Approve'
      this.$swal({
        title: `${actMsg} Data?`,
        text: `Once ${actMsg}, this action cannot be reversed.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, ' + actMsg.toLowerCase() + ' it!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleAction(data, action)
        }
      })
    },
    async handleDelete(item) {
      this.$swal({
        title: 'Delete Data?',
        text: 'Once deleted, this action cannot be reversed.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await this.deleteAdjustmentRunningHour(item.id)
            this.$swal(
              'Success',
              res?.data?.message ?? 'Success Delete Adjusment Running Hours',
              'success'
            )
            this.fetchData()
          } catch (error) {
            this.$swal(
              'Error',
              error.response?.data?.message ??
                'Failed Delete Adjusment Running Hours',
              'error'
            )
          }
        }
      })
    },
    async fetchData(loadValue = true) {
      console.log('fetching data adjustment running hour', this.dataRh)
      this.loading = loadValue
      const params = {
        page: this.adjustments.page,
        perPage: this.adjustments.perPage,
      }
      if (this.dataRh) {
        params.vehicle_id = this.dataRh.item.vehicle_id
        params.vehicle_power_id = this.dataRh.subItem.vehicle_power_id
        params.month = this.dataRh.month
        params.year = this.dataRh.year
      }
      try {
        const res = await this.getAdjustmentRhV3(params)
        if (res?.status === 'success') {
          this.adjustments.data = res.data.data
          this.adjustments.totalPage = res.data.pagination?.totalPages || 0
          this.adjustments.total = res.data.pagination?.total || 0
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>
